module.exports = __webpack_public_path__ + "static/media/ramen.bcadb9e7.jpg";